<form
  class="field-dialog__content__scroll tab-general-user"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fxLayout="column"
  name="form"
  novalidate
  autocomplete="off"
  [formGroup]="userForm"
  *ngIf="userForm"
  fusePerfectScrollbar
>
  <div *ngIf="user.authenticationInfo?.status === 'FORCE_CHANGE_PASSWORD'" class="tab-general-user__warning">
    <mat-icon class="tab-general-user__warning__icon">warning</mat-icon>
    <span class="tab-general-user__warning__text">{{ 'USERS.DIALOG.CHANGE_PASSWORD_WARNING' | translate }}</span>
  </div>

  <div class="tab-general-user__content">
    <div class="tab-general-user__avatar">
      <div class="tab-general-user__avatar__image">
        <img
          (click)="openChangeAvatarDialog()"
          [src]="
            user.avatarUrl ||
            (isOnEditDialog ? 'https://ui-avatars.com/api/?name=' + user.name : 'assets/images/avatars/avatar.jpg')
          "
          (mouseenter)="imageHover = true"
          (mouseleave)="imageHover = false"
          alt="user avatar"
        />
        <div *ngIf="imageHover" class="tab-general-user__avatar__image--on-hover">
          <mat-icon matSuffix>edit</mat-icon>
        </div>
      </div>
      <span *ngIf="isOnEditDialog" class="tab-general-user__avatar__edit-image-message">
        {{ 'USERS.DIALOG.EDIT_AVATAR' | translate }}
      </span>
      <span *ngIf="!isOnEditDialog" class="tab-general-user__avatar__edit-image-message">
        {{ 'USERS.DIALOG.ADD_AVATAR' | translate }}
      </span>
    </div>

    <div class="tab-general-user__content__forms field-outline-form">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ 'USERS.HEADER.NAME' | translate }}
        </mat-label>
        <input [required]="!isOnEditDialog" matInput type="text" formControlName="name" />
        <mat-error *ngIf="userForm.get('name').hasError('required')">
          {{ 'USERS.DIALOG.ERROR.NAME_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>
          {{ 'USERS.HEADER.EMAIL' | translate }}
        </mat-label>
        <input [required]="!isOnEditDialog" type="email" matInput formControlName="email" />
        <mat-error *ngIf="userForm.get('email').hasError('required')">
          {{ 'USERS.DIALOG.ERROR.EMAIL_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="userForm.get('email').hasError('email')">
          {{ 'USERS.DIALOG.ERROR.INVALID_EMAIL' | translate }}
        </mat-error>
        <mat-error *ngIf="userForm.get('email').hasError('user_email_duplicated')">
          {{ 'USERS.DIALOG.ERROR.EMAIL_DUPLICATED' | translate }}
        </mat-error>
      </mat-form-field>

      <div class="tab-general-user__content__forms__access-type">
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'USERS.HEADER.TYPE' | translate }}
          </mat-label>
          <mat-select formControlName="type" [required]="!isOnEditDialog">
            <mat-option value="all">{{ 'USERS.USER_TYPE.ADMIN' | translate }}</mat-option>
            <mat-option value="admin">{{ 'USERS.USER_TYPE.MANAGER' | translate }}</mat-option>
            <mat-option value="requester">{{ 'USERS.USER_TYPE.REQUESTER' | translate }}</mat-option>
          </mat-select>
          <mat-error *ngIf="userForm.get('type').hasError('required')">
            {{ 'USERS.DIALOG.ERROR.TYPE_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'USERS.HEADER.LOGIN_TYPE' | translate }}
          </mat-label>
          <mat-select formControlName="loginProvider" [required]="!isOnEditDialog">
            <mat-option value="email-password">{{
              'USERS.HEADER.LOGIN_TYPE_OPTIONS.EMAIL_AND_PASSWORD' | translate
            }}</mat-option>
            <mat-option value="google">{{ 'USERS.HEADER.LOGIN_TYPE_OPTIONS.GOOGLE' | translate }}</mat-option>
            <mat-option value="active-directory">{{
              'USERS.HEADER.LOGIN_TYPE_OPTIONS.ACTIVE_DIRECTORY' | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field
        *ngIf="isNewUser"
        (click)="hasUsersEditPermission ? openChangePasswordDialog() : null"
        [matTooltip]="!hasUsersEditPermission ? ('USERS.DIALOG.HAS_NOT_PERMISSION' | translate) : ''"
        appearance="outline"
        class="tab-general-user__content__forms__password"
      >
        <mat-label *ngIf="isOnEditDialog">
          {{ 'USERS.HEADER.CURRENT_PASSWORD' | translate }}
        </mat-label>
        <mat-label *ngIf="!isOnEditDialog">
          {{ 'USERS.HEADER.PASSWORD' | translate }}
        </mat-label>
        <input
          matInput
          [disabled]="!hasUsersEditPermission"
          type="password"
          [value]="isOnEditDialog || user['password'] ? '*****************' : null"
          readonly
        />
        <button mat-icon-button matSuffix class="tab-general-user__content__forms__password__button" type="button">
          <mat-icon matSuffix>edit</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</form>
